import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
// Import Firebase dependencies.
import firebase from 'firebase/app';
import 'firebase/auth';
import { FirebaseAuth } from '@firebase/auth-types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {
  private config: any;
  public status: string;
  public environmentIapEndpoints: any;

  constructor(private route: ActivatedRoute) {
    this.config = environment.firebaseConfig
    this.environmentIapEndpoints = environment.environmentIapEndpoints
  }

  ngOnInit(): void {
    var code = this.route.snapshot.queryParams['oobCode'];
    var apiKey = this.route.snapshot.queryParams['apiKey'];
    const auth = this.getAuth(apiKey);
    
    auth
    .applyActionCode(code)
    .then(() => {
        console.log("User's email has been verified")
        this.status = "verified";
    })
    .catch(err => {
        console.log(err);
        this.status = "error";
    });
  }


  private getAuth(apiKey: string): FirebaseAuth {
    let auth = null;
    console.log(apiKey)
    if (apiKey !== this.config.apiKey) {
      throw new Error('Invalid project!');
    }
    try {
      auth = firebase.app().auth();
    } catch (e) {
      const app = firebase.initializeApp(this.config, '[DEFAULT]');
      auth = app.auth();
    }
    return auth;
  }
}
